import { createIconComponent } from '../../factory/create-icon-component';
export const ChevronRightIcon = createIconComponent(
  'ChevronRightIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.675 14.487L13.6454 16.5165C11.4825 18.6794 10.4011 19.7609 9.47261 19.834C8.66698 19.8974 7.87969 19.5713 7.35486 18.9568C6.75 18.2486 6.75 16.7192 6.75 13.6604V8.1802C6.75 6.32025 6.75 5.39027 6.9821 4.88706C7.53374 3.69109 8.91211 3.12015 10.1479 3.57576C10.6678 3.76747 11.3254 4.42506 12.6406 5.74023L12.6406 5.74025L15.5859 8.68554L15.675 8.77464L15.675 8.77465C16.6747 9.7744 17.1746 10.2743 17.3619 10.8507C17.5267 11.3577 17.5267 11.9039 17.3619 12.411C17.1746 12.9874 16.6747 13.4873 15.675 14.487Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
